import { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { StickerTabs } from '../components/StickerTabs';
import { RichTextEditor } from '@mantine/rte';
import axios from 'axios';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { insertCommentMention } from '../utils/commentMentionInsert';
import { insertStickerIntoRichTextEditor } from '../utils/richTextStickerInsert';


type CommenBoxPropsType = {
  chatId: any;
  onSubmit: any;
  register?: any;
  handleSubmit?: any;
  setValue?: any;
  stickerData: any;
};

type FormData = {
  chat_msg: string;
  chat_id: number;
};

export const CommentBox: React.FC<CommenBoxPropsType> = ({
  chatId,
  onSubmit,
  stickerData,
}) => {
  const { register, setValue, handleSubmit } = useForm<FormData>();
  const [showSticker, SetShowSticker] = useState<any | string>(false);
  const token = localStorage.getItem('token');

  const [text, setText] = useState('');
  
  const textRef = useRef(null);
  const selectedMentionRef = useRef('');
  
  const [ filterUser, setFilterUser ] = useState<any[]>([]);
  const [ searchText, setSearchText ] = useState('');

  useEffect(() => {
    setValue('chat_msg', text);
    if (text === '' || text === '<p><br></p>') {
      setFilterUser([]);
    }
  
    }, [setValue, text]);

  
  const syncTextToForm = (nextText: string) => {
    setText(nextText);
    setValue('chat_msg', nextText, { shouldDirty: true });
  };

  const onClickSticker = (data: any) => {
    setFilterUser([]);
    insertStickerIntoRichTextEditor(textRef, data, text, syncTextToForm);
  }

  let navigate = useNavigate();
  const openSticker = () => {
    if (token === null) {
      navigate('/disneyland/login');
    } else {
      SetShowSticker(!showSticker);
    }
  };

  const mentions = useMemo(
    () => ({
      allowedChars: /^[A-Za-z0-9_\-\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      source: (
        searchTerm: any,
        renderList: any,
        mentionChar: any,
        _callback: any
      ) => {
        setSearchText(searchTerm);
        const normalizedSearchTerm = String(searchTerm ?? '').toLowerCase();

        if (
          selectedMentionRef.current &&
          normalizedSearchTerm === selectedMentionRef.current
        ) {
          selectedMentionRef.current = '';
          setFilterUser([]);
          renderList([]);
          return;
        }

        if (mentionChar !== '@' || searchTerm.length === 0) {
          setFilterUser([]);
          renderList([]);
        } else {
          axios
            .get(GET_BASE_URL + '/api/v1/getUser?name=' + searchTerm)
            .then((response: any) => {
              const includesSearchTerm = response.data.data.filter(
                (item: any) =>
                  item.value.toLowerCase().includes(searchTerm.toLowerCase())
              );

              setFilterUser(includesSearchTerm);
              renderList([]);
            });
        }
      },
    }),
    []
  );

  const onChangeFilterUser = (item: any) => {
    const username = String(item?.value ?? '').replace(/^@/, '').trim();
    const normalizedUsername = username.toLowerCase();

    if (normalizedUsername) {
      selectedMentionRef.current = normalizedUsername;
      window.setTimeout(() => {
        if (selectedMentionRef.current === normalizedUsername) {
          selectedMentionRef.current = '';
        }
      }, 1000);
    }

    const nextText = insertCommentMention({
      editor: (textRef.current as any)?.getEditor?.(),
      currentText: text,
      searchText,
      username,
    });

    setText(nextText);
    setValue('chat_msg', nextText);
    setSearchText('');
    setFilterUser([]);
  }

  const submitComment = async (data: FormData) => {
    const didPost = await onSubmit(data);
    if (didPost) {
      setText('');
      setFilterUser([]);
      SetShowSticker(false);
    }
  };

  return (
    <div >
      
      <form
        className='space-y-6'
        onSubmit={handleSubmit(submitComment)}
        method='POST'
      >
        <div className='com-box-main' style={{'position': 'relative'}}>
          {filterUser.length > 0 && (
          <div className="tagUserList mw-mention-picker" role="listbox" aria-label="Tag a MouseWait user">
          {
            filterUser.map((item, index) => {
              return (
                <div className="tagUserItem" key={item?.id ?? item?.value ?? index}>
                  <button
                    type="button"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => onChangeFilterUser(item)}
                    className="button"
                  >
                    <div>
                      <img
                        style={{ verticalAlign: 'middle' }}
                        src={
                          GET_BASE_URL_IMAGE +
                          '/disneyland/images/thumbs/' +
                          item['image']
                        }
                        className='com-imggg'
                        alt=""
                      />
                    </div>
                    
                    <div>
                      @{item['value']}
                    </div>
                  </button>
                </div>
              )
            })
          }
          </div>
          )}

          <div className='com-box d-flex'>
            <RichTextEditor
              id='rte'
              placeholder='Add your magic...'
              mentions={mentions}
              value={text}
              onChange={setText}
              controls={[[]]}
              ref={textRef}
            />

            <input
              type='hidden'
              readOnly={true}
              {...register('chat_id')}
              defaultValue={chatId}
            />

            <div className='icon-ic d-flex'>
              <div className='icon-ic0' onClick={handleSubmit(submitComment)}></div>
              <div className='icon-ic1' onClick={openSticker}></div>
            </div>
          </div>
        </div>
      </form>
      {showSticker === true && (
        <div className='mw-sticker-popover-wrap'>
          <button
            type='button'
            className='mw-sticker-popover-close'
            aria-label='Close sticker picker'
            onClick={() => SetShowSticker(false)}
          >
            ×
          </button>
          <StickerTabs
            tabData={stickerData}
            onClickSticker={onClickSticker}
            onStickerInserted={() => SetShowSticker(false)}
          />
        </div>
      )}
    </div>
  );
};
